import { TablePagination } from '@mui/material';
import React, { useEffect } from 'react';
import { TABLE_ROW_COUNT_OPTIONS } from '../../../helpers/constants';
import { handleChangeRowsPerPage, handlePageChange } from '../../../helpers/handleTableFunctions';
import { useTranslation } from 'react-i18next';

const VenuesPagination = ({ rows, total, limit, page, setParams }) => {
    const { t } = useTranslation();

    // Snap back to the previous page when the current page becomes empty
    // (e.g. after deleting the last row on a page). The page index is owned by
    // the parent, so reacting to freshly fetched data stays an effect.
    useEffect(() => {
        if (rows?.length === 0 && page > 0) {
            setParams({ limit, page: page - 1 });
        }
    }, [rows, limit, page, setParams]);

    return (
        <TablePagination
            count={total || 0}
            rowsPerPage={limit}
            component="div"
            page={rows?.length <= 0 ? 0 : page}
            onPageChange={(_, newPage) => handlePageChange(newPage, setParams)}
            rowsPerPageOptions={TABLE_ROW_COUNT_OPTIONS}
            onRowsPerPageChange={(event) => handleChangeRowsPerPage(event, setParams)}
            labelRowsPerPage={t('labelRowsPerPage')}
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} / ${count}`}
        />
    );
};

export default VenuesPagination;
